import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchTripDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
  setKeyboardShortcuts,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CtART from "./CustomTool/ResponsiveTable";

class TripList extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      cmbDRP: "All",
    },

    columns: [
      {
        accessorKey: "bint_tripcode",
        header: " Trip Code",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_tripdateDMY",
        header: "Trip Date",
        size: 80,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_truckno",
        header: " Truck No.",
        size: 100,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_customer",
        header: "Party",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 100,
      },

      {
        accessorKey: "vac_departure",
        header: " Departure",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_destination",
        header: " Destination",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_netwt",
        header: " Net Wt",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },

      {
        accessorKey: "dec_transportrate",
        header: " Tran. Rate",
        size: 75,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },
      {
        accessorKey: "dec_transportamount",
        header: " Amount",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },
      {
        accessorKey: "vac_driver",
        header: "Driver",
        size: 80,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_triprate",
        header: "Rate",
        size: 45,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },
      {
        accessorKey: "vac_waybridgename",
        header: "Way-Bridge",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_waybridgecharge",
        header: "Charge",
        size: 55,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },
      {
        accessorKey: "vac_wbc_trantype",
        header: "Tran Type",
        size: 75,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_triptotalamount",
        header: "Total Amt",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
        isNumeric: true,
      },
      {
        accessorKey: "dec_distance",
        header: "Dist.(KM)",
        size: 65,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
      },
      {
        accessorKey: "dec_diseal",
        header: "Die.(Ltr)",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Trip List";
    this.props.setActiveMenu("TripList");
    this.ShortCut();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Receipt",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.getInfo();
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_tripcode = row.getValue("bint_tripcode"),
      truck = row.getValue("vac_truckno");

    console.log(bint_tripcode);

    this.DeleteData(bint_tripcode, truck);
  };

  DeleteData = (bint_tripcode, truck) => {
    if (bint_tripcode > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want Delete to Trip Code : " +
              bint_tripcode +
              " and Truck No : " +
              truck +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteTrip(bint_tripcode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteTrip = (bint_tripcode) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteTrip",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      bint_tripcode: bint_tripcode,
      // bol_list: true,
    };
    fetchTripDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.TripList && res.data.TripList.length > 0) {
            rows = res.data.TripList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              // this.clearInfo();
            }
          );
          // document.getElementById("cmbTruckNo").focus();
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };
  //   console.log("row", row);
  //   // console.log('row.original["bint_tripcode"]', row.original["bint_tripcode"]);
  //   const txtTripCode = row.getValue("bint_tripcode"),
  //     dtpdate = row.getValue("dat_tripdate"),
  //     cmbTruckNo = row.getValue("vac_truckno"),
  //     cmbDriver = row.getValue("vac_driver"),
  //     cmbPartyCustomer = row.getValue("vac_customer"),
  //     txtItemTotal = row.getValue(""),
  //     txtTripRate = row.getValue("dec_triprate"),
  //     cmbWayBridge = row.getValue("vac_waybridgename"),
  //     txtWayBridgeCharge = row.getValue("dec_waybridgecharge"),
  //     txtTripTotalAmount = row.getValue("dec_triptotalamount"),
  //     cmbDeparture = row.getValue("vac_departure"),
  //     cmbDestination = row.getValue("vac_destination"),
  //     txtNetWt = row.getValue("dec_netwt"),
  //     txtTransportRate = row.getValue("dec_transportrate"),
  //     txtTransportAmount = row.getValue("dec_transportamount"),
  //     cmbType = row.getValue("vac_wbc_trantype"),
  //     txtDiseal = row.getValue("dec_diseal"),
  //     txtDistance = row.getValue("dec_distance");
  //   // const rows2 = row.original.CheckToDoList;
  //   // console.log("rows2", rows2);
  //   // this.setState({
  //   //   formData: {
  //   //     ...this.state.formData,
  //   //     txtTripCode,
  //   //     txtPlaceName,
  //   //   },
  //   // });
  //   this.props.navigateTo("TripEntry");
  // navigateTripEntry = (bint_acid, bint_tripcode, bint_acyear) => {

  // };

  //   window.scrollTo(0, 0);
  //   document.getElementById("txtPlaceName").focus();
  handleARDonActionClick_Edit = (row) => {
    let bint_acid = localStorage.getItem("acid"),
      bint_tripcode = row.getValue("bint_tripcode"),
      bint_acyear = localStorage.getItem("ACY");
    this.props.navigateTo("TripEntry", {
      bint_acid: bint_acid,
      bint_tripcode: bint_tripcode,
      bint_acyear: bint_acyear,
    });
  };

  handleOnNewEntryClick = () => {
    this.removeKeyboardShortCuts();
    this.props.navigateTo("TripEntry");
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateTrip = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate,
      toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter FromDate", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter ToDate", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
    //   dtpToDate = get_YMD_from_SYS(new Date());
    const { fromdate, todate } = getlocalstoragedate("Receipt");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.onFormLoad();
      }
    );
  };
  onFormLoad = () => {
    if (this.validateTrip()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        let reqData = {
          Op: "ListTrip",
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
          // bint_ci: localStorage.getItem("CI"),
          // bint_tripcode: this.state.formData.txtTripCode,
        };

        fetchTripDetail(reqData)
          .then((res) => {
            let dataLoadStatus = true,
              rows = [];
            this.props.closeUpdateProcessing();

            if (res.data.TripList && res.data.TripList.length > 0) {
              rows = res.data.TripList;
            }
            this.setState({
              dataLoadStatus,
              rows,
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in onFormLoad.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  handleOnList = () => {};

  render() {
    return (
      <from>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="From Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              nextCtrlID={"dtpToDate"}
              // disabled={this.state.disabledProfileData.DOBDS}
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              defaultAction={this.onFormLoad}
              // disabled={this.state.disabledProfileData.DOBDS}
            />
          </Grid>

          {/* <Grid item>
            <CtBtn label="List" onClick={this.onFormload} />
          </Grid> */}

          <Grid item>
            <CtBtn
              id="btnLoad"
              label="Load"
              variant={"outlined"}
              onClick={() => {
                this.onFormLoad();
              }}
            />
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("Trip Entry")}
            newBtnName={"New Trip"}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            tableButtonAction={[
              {
                label: "Trip Entry",
                onClick: this.handleOnNewEntryClick,
                addPluseIcon: true,
              },
            ]}
            showColumnFilters={false}
            actionColSize={90}
            hideColIdList={[""]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </from>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(TripList))));
